import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Group, GroupStructure, Product } from 'app/models/menu.model';
import * as MenuSelectors from 'app/reducers/menu.selectors';
import { firstValueFrom } from 'rxjs';
import { MenuScheduleModalData } from 'app/models/menu.schedule.model';

@Component({
  selector: 'app-select-products-schedule-modal',
  templateUrl: './select-products-schedule-modal.component.html',
  styleUrls: ['./select-products-schedule-modal.component.scss']
})
export class SelectProductsScheduleModalComponent implements OnInit {
  originalGroups: Group[]  = [];
  products: Map<string, Product> = new Map<string, Product>();
  menuSchedule: MenuScheduleModalData;
  selectedExternalProductIds: Set<string> = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<SelectProductsScheduleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MenuScheduleModalData,
    private translate: TranslateService,
    private store: Store,
  ) {
    this.menuSchedule = this.data;
    this.menuSchedule.externalProductIds?.forEach(id => this.selectedExternalProductIds.add(id));
  }

  async ngOnInit() {
    const [groups, products] = await Promise.all([
      firstValueFrom(this.store.select(MenuSelectors.selectOriginalDictionaryGroups)),
      firstValueFrom(this.store.select(MenuSelectors.selectDictionaryProducts)),
    ]);
    this.originalGroups = [...groups.values()];
    this.products = products;
  }

  get title(): string {
    return this.translate.instant('MENU.SELECT_SCHEDULE_DISHES', {name: this.menuSchedule.name});
  }

  allDishesFromGroupSelected(groupStructure: GroupStructure): boolean {
    const products = this.getProductsFromGroup(groupStructure);
    return (products.length > 0) && products
      .map(product => this.isSelectedProduct(product))
      .every(selected => selected);
  }

  getProductsFromGroup(groupStructure: GroupStructure): Product[] {
    const products: Product[] = [];
    for (const productInGroup of groupStructure.productsInGroup) {
      if (this.products.has(productInGroup.externalProductId)) {
        products.push(this.products.get(productInGroup.externalProductId));
      }
    }
    return products;
  }

  handleCheckGroup(groupStructure: GroupStructure, checked): void {
    this.getProductsFromGroup(groupStructure).forEach((product) => {
      this.handleCheckProduct(product, checked);
    });
  }

  save() {
    const externalProductIds: string[] = [];
    this.selectedExternalProductIds.forEach(id => externalProductIds.push(id));
    this.menuSchedule.externalProductIds = externalProductIds;
    this.dialogRef.close();
  }

  handleCheckProduct(product: Product, checked: boolean): void {
    if (checked) {
      this.selectedExternalProductIds.add(product.externalId);
    } else {
      this.selectedExternalProductIds.delete(product.externalId);
    }
  }

  isSelectedProduct(product: Product) {
    return this.selectedExternalProductIds.has(product.externalId);
  }
}
